import httpClient from "@/http-client";

export const get = (Options = {}) => {
    return httpClient
        .get("/api/holiday-rules", Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const store = data => {
    return httpClient
        .post("/api/holiday-rules", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const substitute = (Option = {}) => {
    return httpClient
        .get("/api/holiday-rules/substitutes", Option)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};
export default {
    get,
    store,
    substitute
};
